
import Footer from "../../../../../src/Footer.tsx";
import Header from "../defaults/Header.tsx";
import Logo from "../../../../../src/Logo.tsx";
import InfoBar from "../defaults/InfoBar.tsx";
import Breadcrumbs from "../defaults/Breadcrumbs.tsx";
import SectionNav from "../defaults/SectionNav.tsx";

const brandName = "AngleSharp";

export { Footer, Header, Logo, InfoBar, Breadcrumbs, SectionNav, brandName };
